import React, { ComponentClass, FunctionComponent } from 'react';

import { IconChartBar, IconFileText, IconKey, IconTool } from '@tabler/icons-react';

import APIKeys from './APIKeys';
import Docs from './Docs';
import Usage from './Usage';
import Webhooks from './Webhooks';

export interface ITabConfig {
  icon: React.ReactNode;
  link: string;
  name: string;
  path: string;
  component: ComponentClass | FunctionComponent;
  isDisabled?: boolean;
}

// Canonical list of tabs and routes. First tab here will automatically be the landing tab.
export const Tabs: Array<ITabConfig> = [
  {
    icon: <IconKey size={24} />,
    link: '/keys',
    name: 'API Keys',
    path: 'keys',
    component: APIKeys,
  },
  {
    icon: <IconTool size={24} />,
    link: '/webhooks',
    name: 'Webhooks',
    path: 'webhooks',
    component: Webhooks,
  },
  {
    icon: <IconChartBar size={24} />,
    link: '/usage',
    name: 'Usage Logs',
    path: 'usage',
    component: Usage,
  },
  {
    icon: <IconFileText size={24} />,
    link: '/documentation',
    name: 'Documentation',
    path: 'documentation',
    component: Docs,
  },
];
